export const ACCEPTABLE_FILE_TYPES = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,image/*'
